import { provideInstrumentDetailDomain } from '@zero/instrument-details/domain';
import { provideDerivativeSearchDomain } from '@zero/leverage-products/domain';
import { provideTradeDomain } from '@zero/trade/domain';

export const INSTRUMENT_DETAILS_WEB_ROUTES = [
  {
    path: '',
    loadComponent: () =>
      import('./pages/instrument-details-page-web/instrument-details-page-web.component').then((m) => m.InstrumentDetailsPageWebComponent),
    providers: [provideDerivativeSearchDomain(), provideTradeDomain()],
  },
  {
    path: ':id',
    loadComponent: () =>
      import('./pages/instrument-details-page-web/instrument-details-page-web.component').then((m) => m.InstrumentDetailsPageWebComponent),
    providers: [provideDerivativeSearchDomain(), provideTradeDomain()],
  },
  {
    path: ':id/timeline',
    loadComponent: () => import('./components/asset-timeline-web/asset-timeline-web.component').then((m) => m.AssetTimelineComponent),
    providers: [provideInstrumentDetailDomain()],
  },
];
